import { Component, Vue } from 'vue-property-decorator';

import RoomTable from '@/components/room-table';
import { readableDate, translateWeekdays, isOffDay, findDate } from '@/utilities/index';
import { Room, Company, Calendar } from '@/definitions';

import ApiService from '@/services/api.service';

import template from './home.vue';
import { Action } from '@/store';
import { nl, enUS } from 'date-fns/locale';
import { isBefore, startOfDay } from 'date-fns';

@Component({
  mixins: [template],
  components: {
    RoomTable
  },
})
export default class Home extends Vue {
  async mounted() {
    await ApiService.getCompany();
    if (!translateWeekdays(this.calendar).includes(this.planningDate.getDay()) || isOffDay(this.planningDate, this.calendar) || isBefore(this.planningDate, startOfDay(new Date()))) {
      this.setDate(findDate(1, this.planningDate, this.calendar));
    } else {
      this.getAppointments(this.planningDate);
    }
  }

  newDate(amount: number, date?: Date) {
    this.setDate(findDate(amount, date || new Date(this.planningDate.toISOString()), this.calendar));
  }

  setDate(date: Date) {
    this.$Store.dispatch(Action.SET_NEW_DATE, date);
    this.getAppointments(date);
  }

  async getAppointments(date: Date) {
    try {
      await ApiService.getAppointments(date);
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.appointments.retrieve_error', type: 'danger' });
    }
  }

  get company(): Company {
    return this.$Store.state.company.company;
  }

  get calendar(): Calendar {
    return this.$Store.state.company.company.calendar;
  }

  get planningDate(): Date {
    return new Date(this.$Store.state.date.date);
  }

  get appointments(): Room[] {
    return this.$Store.state.appointments;
  }

  get subtitleInfo(): {} {
    return {
      company: this.$Store.state.user.company,
      date: readableDate(this.planningDate, this.$i18n.locale === 'nl' ? nl : enUS),
      seats: this.numOfSeats
    };
  }

  get numOfSeats(): number {
    if (this.$Store.state.appointments) {
      return this.$Store.state.appointments.reduce((a, b) => a + b.seats.length, 0);
    } else {
      return 0;
    }
  }

}